import { PillToggleGroupOption } from '@components/pill-toggle-group';
import { SupportedLanguages } from '@constants/constants.type';
import { LANGAUAGE_PRIORITY } from '@constants/global';

/**
 * Returns the language pill options for the tab strip. Re-uses `LANGAUAGE_PRIORITY`
 * (constants/global) as the canonical locale ordering — the Figma layout treats
 * the order as illustrative, so there's no need to maintain a separate list.
 * The main language is filtered out, so `en` only appears when another language
 * is the venue/user main.
 */
export const buildTabOptions = (mainLanguage: SupportedLanguages): PillToggleGroupOption<SupportedLanguages>[] =>
  LANGAUAGE_PRIORITY.filter((lc) => lc !== mainLanguage).map((lc) => ({
    value: lc,
    label: lc.toUpperCase(),
    variant: 'neutral',
    // `indicator` left unset on purpose — reserved for the future
    // auto-translation "needs review" dot.
  }));
